import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { getAllParentIds } from 'utils/tree';
import areArraysEqual from 'utils/areArraysEqual';
import { checkIsValidPlaylistContentState } from './checkIsValidPlaylistState';
import { moveItemsAndReturnNewState } from './moveItemsAndReturnNewState';
import { sortByRank } from '.';

/**
 * Determines whether or not the selected items (`selectedItemIds`) can be moved to a
 * specific target location (represented by a `targetParentId` and `targetRankInSection`).
 */

export function checkIsValidMoveTarget(_ref) {
  var isMovingEnabled = _ref.isMovingEnabled,
    content = _ref.content,
    selectedItemIds = _ref.selectedItemIds,
    targetParentId = _ref.targetParentId,
    targetRankInSection = _ref.targetRankInSection;
  if (!isMovingEnabled || selectedItemIds.length === 0) {
    return false;
  }
  var siblingItems = content.filter(function (item) {
    return item.parent_id === targetParentId;
  });

  /**
   * Exclude this target if it's located inside of a section
   * that is selected. (Prevent moving sections into themselves)
   */
  if (targetParentId && selectedItemIds.some(function (id) {
    var isTargetParentSelected = id === targetParentId;
    if (isTargetParentSelected) {
      return true;
    }
    var allParentIds = getAllParentIds(content, {
      parent_id: targetParentId
    });
    return allParentIds.includes(id);
  })) {
    return false;
  }

  /**
   * We simulate a move to the new location and compare the items
   * at the target location with the current items.
   * If they're the same, moving will have no effect and we return `false`.
   */
  var simulatedStateAfterMove = moveItemsAndReturnNewState({
    content: content,
    itemIdsToMove: selectedItemIds,
    targetParentId: targetParentId,
    targetRankInSection: targetRankInSection
  });

  /**
   * Return early if the simulated state isn't valid.
   */
  if (!checkIsValidPlaylistContentState({
    content: simulatedStateAfterMove
  })) {
    return false;
  }

  /**
   * Check whether moving here would actually change the playlist,
   * return false if not – we don't want to allow "pointless" moves
   */
  var siblingItemIds = siblingItems.sort(sortByRank).map(function (item) {
    return item.id;
  });
  var siblingItemIdsAfterMove = simulatedStateAfterMove.filter(function (item) {
    return item.parent_id === targetParentId;
  }).sort(sortByRank).map(function (item) {
    return item.id;
  });
  if (areArraysEqual(siblingItemIds, siblingItemIdsAfterMove)) {
    return false;
  } else {
    return true;
  }
}